import { BaseObject } from '../_models/base-object';
import { BaseFuelGasSplitterFormGroupMapper } from './base-fuel-gas-splitter-form-group.mapper';

export class FuelGasSplitterFormGroupMapper extends BaseFuelGasSplitterFormGroupMapper {
  override map(source: BaseObject, destination: BaseObject) {
    super.map(source, destination);
  }
}
